import useUIBp from "../../../../../../Hooks/useUIBoilerplate";
import { c365devicesListDataId } from "../../../../../Reports/Actions/getc365List";
import BasicRow from "../../../../../UI/BasicLayout/Components/BasicRow";
import Actions from "./Components/Actions";
import Admin from "./Components/Admin";
import Connected from "./Components/Connected";
import Devices from "./Components/Devices";
import Name from "./Components/Name";
import Username from "./Components/Username";

// const rowData = {
//   id: "", // for select
//   disabled, // for select
//   elements: [{ xs, content: "ELEMENT" }],
// };
const fontSize = 13;

const UserRow = (props) => {
  const { auth, warehouse } = useUIBp();
  const { login, name, machines: devices = 0, level,suspensions } = props;
  const { tunnels: allTunnels = {} } = warehouse;
  const c365devices = warehouse[c365devicesListDataId] ?? [];
  const tunnels = allTunnels[login] ?? [];
  let connected = tunnels.length;

  const isConnectedTo365 = !!c365devices[props.login]

  if (isConnectedTo365) {
    connected += 1;
  }

  const data = {
    id: login,
    disabled: login === auth.user,
    elements: [
      { content: <Admin {...{ login,level }} />, justify: "center", size: 0.7 },
      { content: <Username {...{ login, fontSize }} />, size: 3.5 },
      { content: <Name {...{ name, fontSize }} />, size: 3.2 },
      {
        content: <Devices {...{ devices, suspensions, fontSize }} />,
        justify: "center",
        size: 1.5,
      },
      {
        content: <Connected {...{ connected, fontSize }} />,
        justify: "center",
        size: 1.5,
      },
      {
        content: <Actions {...props} {...{ tunnels, isConnectedTo365 }} />,
        justify: "end",
        size: "grow",
      },
    ],
  };

  return <BasicRow {...data} />;
};

export default UserRow;
